import React, { useEffect, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import ApplicationSkeleton from "../Skeleton/Application";
import ApplicationCard from "./Card";
import NoDataFound from "../NoDataFound";

const { GridView } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const AssignedApplication = ({ search }) => {
  const configData = useUnoSelector((state) => state.config);
  const myApplications = useUnoSelector((state) => state.application);
  const [myAppList, setMyAppList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const _myAppData = myApplications?.apps || [];
    setMyAppList(_myAppData?.filter((item) => item.uuid !== configData.config.applicationId));
    setLoading(myApplications.loading);
  }, [myApplications]);

  let list = myAppList.filter(
    (item) =>
      item?.name?.toLowerCase()?.includes(search?.toLowerCase()) && item.uuid !== configData.config.applicationId
  );

  return (
    <>
      {loading ? (
        <ApplicationSkeleton length={10} />
      ) : (
        <>
          {list.length > 0 ? (
            <>
              <GridView>
                {list.map((app, index) => {
                  return <ApplicationCard item={app} />;
                })}
              </GridView>
            </>
          ) : (
            <div className="no-data">
              <NoDataFound headText="No Application found." infoText="" />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AssignedApplication;
